module.exports = __webpack_public_path__ + "static/media/tt_commons_regular-webfont.c98147c2.woff";